module.exports = __webpack_public_path__ + "static/media/imagen-principal-sobre-agromyss.53289856.jpg";